import React from "react";
import PropTypes from "prop-types";
import stickybits from "stickybits";

import styles from "./GlobalNavigation.scss";
import a from "../TextLink";
import { Container } from "../Container";

export class GlobalNavigation extends React.Component {
  static propTypes = {
    mainItems: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        url: PropTypes.string,
        isActive: PropTypes.bool,
      })
    ).isRequired,
    additionalItems: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        url: PropTypes.string,
        isActive: PropTypes.bool,
      })
    ),
  };

  static defaultProps = {
    additionalItems: null,
  };

  static displayName = "GlobalNavigation";

  constructor(props) {
    super(props);

    this.state = {
      isHidden: false,
    };

    this.prev = 0;

    this.ref = React.createRef();
  }

  componentDidMount() {
    this.prev = window.pageYOffset;
    window.addEventListener("scroll", (e) => this.handleNavigation(e));

    this.stickyInstance = stickybits(this.ref.current, {
      stickyBitStickyOffset: 0,
      useStickyClasses: true,
    });
  }

  componentWillUnmount() {
    this.stickyInstance.cleanup();
  }

  handleNavigation = (e) => {
    const window = e.currentTarget;

    if (this.prev > window.pageYOffset) {
      this.setState({
        isHidden: false,
      });
    } else if (this.prev < window.pageYOffset) {
      this.setState({
        isHidden: true,
      });
    }
    this.prev = window.pageYOffset < 0 ? 0 : window.pageYOffset;
  };

  render() {
    const { mainItems, additionalItems } = this.props;
    const { isHidden } = this.state;

    return (
      <>
        <div
          className={`${styles.wrapper} ${isHidden ? "is-hidden" : ""}`}
          data-telekom-global-navigation=""
          ref={this.ref}
        >
          <Container variants={Container.Variant.centered}>
            <Container variants={Container.Variant.fixed}>
              <div className={styles.main}>
                <ul className={styles.list}>
                  {mainItems.map((item) => (
                    <li
                      className={
                        item.isActive ? styles.activeItem : styles.item
                      }
                      key={item.label}
                    >
                      <a href={item.url} className={styles.link}>
                        {item.label}
                      </a>
                    </li>
                  ))}
                </ul>

                {additionalItems ? (
                  <ul className={styles.additionalList}>
                    {additionalItems.map((item) => (
                      <li
                        className={
                          item.isActive ? styles.activeItem : styles.item
                        }
                        key={item.label}
                      >
                        <a href={item.url} className={styles.link}>
                          {item.label}
                        </a>
                      </li>
                    ))}
                  </ul>
                ) : (
                  false
                )}
              </div>
            </Container>
          </Container>
        </div>
      </>
    );
  }
}

export default GlobalNavigation;
